import { render, staticRenderFns } from "./SurveysComponent.vue?vue&type=template&id=482f3fec"
import script from "./SurveysComponent.vue?vue&type=script&lang=js"
export * from "./SurveysComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports